export const APPLICATION_INIT = "APPLICATION_INIT"
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_LOGIN = 'USER_LOGIN'

export const applicationInit = () => dispatch => dispatch({ type: APPLICATION_INIT })

export const logout = () => dispatch => dispatch({ type: USER_LOGOUT, payload: {} })

export const login = code => dispatch => dispatch({ type: USER_LOGIN, payload: { code } })
